import React from "react";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";
import { siteInfo } from "../mock";
import { useSeo } from "../hooks/useSeo";

const Contact = () => {
  useSeo({
    title: "Contact | Jump en Joy",
    description: "Vragen over een reservering of beschikbaarheid? Bel, mail of WhatsApp ons. Wij denken graag mee over de beste attractie voor jouw feest in de regio.",
    keywords: "contact springkussen verhuur, reserveren springkasteel",
  });

  const waNumber = (siteInfo.phoneRaw || "").replace(/[^0-9]/g, "");

  const cards = [
    { icon: Phone, label: "Telefoon", value: siteInfo.phone, href: `tel:${siteInfo.phoneRaw}`, testid: "contact-phone" },
    { icon: MessageCircle, label: "WhatsApp", value: "Stuur ons een bericht", href: `https://wa.me/${waNumber}`, testid: "contact-whatsapp" },
    { icon: Mail, label: "E-mail", value: siteInfo.email, href: `mailto:${siteInfo.email}`, testid: "contact-email" },
  ];

  return (
    <div className="wrap py-12">
      <div className="text-center max-w-2xl mx-auto">
        <span className="inline-block bg-brand-pinklight text-brand-pink text-xs font-bold rounded-full px-4 py-1.5">Contact</span>
        <h1 className="font-display font-bold text-brand-navy text-4xl sm:text-5xl mt-4">Neem contact op</h1>
        <p className="text-slate-500 mt-4">
          Direct reserveren doe je eenvoudig via de <span className="font-semibold text-brand-navy">Huur nu</span>-knop bij elk springkussen.
          Heb je toch een vraag over beschikbaarheid of je feest? Bel, mail of WhatsApp ons gerust — we helpen je graag.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-12 max-w-4xl mx-auto">
        {cards.map(({ icon: Icon, label, value, href, testid }) => (
          <a
            key={label}
            href={href}
            target={href.startsWith("http") ? "_blank" : undefined}
            rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
            data-testid={testid}
            className="group rounded-3xl border border-slate-100 bg-white p-6 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all text-center"
          >
            <span className="w-14 h-14 rounded-2xl bg-brand-bluelight flex items-center justify-center mx-auto group-hover:bg-brand-blue transition-colors">
              <Icon className="w-6 h-6 text-brand-blue group-hover:text-white transition-colors" />
            </span>
            <span className="block text-xs text-slate-400 mt-4">{label}</span>
            <span className="block font-display text-brand-navy text-lg mt-1 break-words">{value}</span>
          </a>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5 max-w-4xl mx-auto">
        <div className="rounded-3xl bg-brand-navy text-white p-6 flex items-start gap-3">
          <span className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0"><MapPin className="w-5 h-5 text-brand-blue" /></span>
          <span><span className="block text-xs text-slate-400">Regio</span>{siteInfo.region}</span>
        </div>
        <div className="rounded-3xl bg-brand-navy text-white p-6 flex items-start gap-3">
          <span className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center shrink-0"><Clock className="w-5 h-5 text-brand-blue" /></span>
          <span><span className="block text-xs text-slate-400">Openingsuren</span>{siteInfo.hours}</span>
        </div>
      </div>
    </div>
  );
};

export default Contact;
